import { render } from "./EdoDocumentPreviewRow.vue?vue&type=template&id=2496307d&scoped=true"
import script from "./EdoDocumentPreviewRow.vue?vue&type=script&lang=js"
export * from "./EdoDocumentPreviewRow.vue?vue&type=script&lang=js"

import "./EdoDocumentPreviewRow.vue?vue&type=style&index=0&id=2496307d&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2496307d"]])

export default __exports__